export function formatCents(cents: number | null | undefined, currency = 'BRL') {
  const v = (cents ?? 0) / 100;
  return v.toLocaleString('pt-BR', { style: 'currency', currency });
}

export function formatDate(iso: string | null | undefined) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTime(iso: string | null | undefined) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatPhone(e164: string | null | undefined) {
  if (!e164) return '—';
  const m = e164.replace(/\D/g, '');
  if (m.length === 13 && m.startsWith('55')) {
    const ddd = m.slice(2, 4);
    const a = m.slice(4, 9);
    const b = m.slice(9, 13);
    return `+55 (${ddd}) ${a}-${b}`;
  }
  return e164;
}

export function formatPercent(pct: number | null | undefined, digits = 1) {
  if (pct === null || pct === undefined) return '—';
  return `${pct.toFixed(digits)}%`;
}
